import { AxiosResponse } from 'axios';
import React from 'react';
import { DateObject } from "react-multi-date-picker"
import { TransactionService } from '../../services/TransactionService';
import { ITransaction, ITransactionWebModelRequest } from "../../requests/ITransactionWebModelRequest";
import { TFunction, withTranslation } from 'react-i18next';
import "../transactions/TransactionReport.css";
import { WebCache } from "../../services/WebCache";
import { IIssuer } from "../../models/IIssuer";
import ErrorsView from '../ErrorsView';
import TextField from '../controls/fields/textField';
import NumericField from '../controls/fields/numericField';
import SelectField from '../controls/fields/selectField';
import DateField from '../controls/fields/dateField';
import { OptionMapperHelper } from '../../helpers/OptionMapperHelper';
import Page from '../containers/page'
import FormFilter from '../containers/form-filter';
import Form from "../containers/form";
import { DateHelper } from '../../helpers/DateHelper';
import NavigationTabLinksForCharges from './NavigationTabLinksForCharges';
import i18next, { t } from 'i18next';
import { ColumnDefinition, actionColumnDefinition, currencyColumnDefinition, dateColumnDefinition, textColumnDefinition } from '../table/ColumnDefinition';
import CustomTable, { TableModeEnum } from '../table/CustomTable';
import { IPageRequest } from '../../models/IPageRequest';
import { Modal } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import LabelMessage from '../LabelMessage';
import SubmitButton from '../controls/buttons/submitButton';
import { TOTPService } from '../../services/TOTPService';
import { toast } from 'react-toastify';
import { AuthenticateTotpDevice } from '../../requests/ITOTPRequest';
import { MconboardingService } from '../../services/Mconboarding';
import { IIssuerTotalDto } from '../../models/IIssuerTotalDto';
import { CurrencyHelper } from '../../helpers/CurrencyHelper';
import TotalTransactions from './TotalTransactions';
import { UtilService } from '../../services/UtilService';
import CustomReCAPTCHA from '../CustomCaptcha';
import { ReactComponent as LogoSVG } from "../../../node_modules/itd-common/assets/images/brand/logo.svg";
import Button from '../controls/buttons/button';
import Swal from "sweetalert2";
import TarjetaLogo from '../../../node_modules/itd-common/assets/images/issuers/PCT-logo.svg';
import { IMessageContext } from "../MessagesContext";
import { withMessages } from "../contexts/MessagesContext";
import Pagination from '../Pagination';

interface IProps {
    t: TFunction
    messages: IMessageContext
}
interface CodeFormType {
    otpCode: string
}
interface ActionResult {
    show: boolean,
    type?: string
}
interface IState {
    fromDate: DateObject,
    toDate: DateObject,
    activePage: number,
    mainPage: number,
    pages: number[],
    transactions: ITransaction[],
    columns: ColumnDefinition[],
    errors: string[],
    operationTypeFilter: string,
    amountFilter: string,
    merchantFilter: string,
    paymentmodeFilter: string,
    muidFilter: string
    issuerFilter: string,
    currentIssuers: IIssuer[],
    terminalFilter: string,
    userNameFilter: string,
    pageRequest: IPageRequest,
    tableMode: TableModeEnum,
    showModalAmount: boolean,
    showModalAuth: boolean,
    showModalConfirmation: boolean,
    issuersByTotal: IIssuerTotalDto[],
    tranId: string,
    selectedTransactions: ITransaction | null,
    mfaDevices: any[],
    isOTPError: boolean,
    enteredAmount: number,
    isAmountValid: boolean,
    isAmountNotEmpty: boolean,
    otpCodeForm: CodeFormType,
    rowDetail: { title: string, total: string, data: Array<{ prop: string, value: string }> } | null,
    isCaptchaVerified: boolean;
}

const pageSize = 13;
const pageQuantity = 3
const defaultPages = [1, 2, 3]
const T_PREFIX: string = 'pages.transactionsQR.';
const allowedOperationTypes = ['all', 'C', 'D'];
type BuildTotalDetailOptions = { object: any, title: string, accumulateTotal: boolean };
class TransfersReturnReport extends React.Component<IProps, IState> {
    private optionMapper: OptionMapperHelper = new OptionMapperHelper(this.props.t);
    private messages: IMessageContext = this.props.messages;

    constructor(props: IProps) {
        super(props);
        let issuerFilter = "";
        let terminalFilter = "";
        let operationTypeFilter = "";
        let userNameFilter = "";
        let [fromDate, toDate] = DateHelper.buildDateRange();

        this.state = {
            fromDate: fromDate,
            toDate: toDate,
            activePage: 1,
            mainPage: 0,
            pages: defaultPages,
            columns: [],
            transactions: [],
            errors: [],
            operationTypeFilter: operationTypeFilter,
            issuerFilter: issuerFilter,
            amountFilter: "",
            terminalFilter: terminalFilter,
            merchantFilter: "",
            paymentmodeFilter: "",
            muidFilter: "",
            currentIssuers: WebCache.getAllIssuers(),
            userNameFilter: userNameFilter,
            tableMode: TableModeEnum.LIST,
            pageRequest: {
                Skip: 0,
                Take: 0
            },
            showModalAmount: false,
            showModalAuth: false,
            showModalConfirmation: false,
            issuersByTotal: [],
            tranId: "",
            selectedTransactions: null,
            mfaDevices: [],
            isOTPError: false,
            enteredAmount: 0,
            isAmountValid: true,
            isAmountNotEmpty: false,
            otpCodeForm: {
                otpCode: ''
            },
            rowDetail: null,
            isCaptchaVerified: sessionStorage.getItem('captchaVerified') == "true"
        }
        this.processAction = this.processAction.bind(this);
    }

    getTransactionRequest = (all: boolean) => {
        let from_year: number;
        let from_month: number;
        let from_day: number;
        let to_year: number;
        let to_month: number;
        let to_day: number;
        from_year = this.state.fromDate.year;
        from_month = this.state.fromDate.month.number;
        from_day = this.state.fromDate.day;
        to_year = this.state.toDate.year;
        to_month = this.state.toDate.month.number;
        to_day = this.state.toDate.day;

        const tranWebModel: ITransactionWebModelRequest = {
            From: new Date(from_year, from_month - 1,
                from_day,
                this.state.fromDate.hour - 3,
                this.state.fromDate.minute).toJSON(),
            To: new Date(to_year,
                to_month - 1,
                to_day,
                this.state.toDate.hour - 3,
                this.state.toDate.minute).toJSON(),
            OperationType: (this.state.operationTypeFilter == null || this.state.operationTypeFilter == "" || this.state.operationTypeFilter.toLowerCase() == "all") ? "" : this.state.operationTypeFilter,
            Amount: (this.state.amountFilter == null || this.state.amountFilter == "") ? "" : this.state.amountFilter,
            MerchantCodes: (this.state.merchantFilter == null || this.state.merchantFilter == "") ? [] : [this.state.merchantFilter],
            Issuer: (this.state.issuerFilter == null || this.state.issuerFilter == "0000") ? "" : this.state.issuerFilter,
            Terminals: (this.state.terminalFilter == null || this.state.terminalFilter == "") ? [] : [WebCache.getCurrentUser()?.countryId == 1 ? "B24_" + this.state.terminalFilter : this.state.terminalFilter],
            PaymentMode: (this.state.paymentmodeFilter == null || this.state.paymentmodeFilter == "") ? "" : this.state.paymentmodeFilter,
            MuId: (this.state.muidFilter == null || this.state.muidFilter == "") ? "" : this.state.muidFilter,
            UserId: (this.state.userNameFilter == null || this.state.userNameFilter == "") ? "" : this.state.userNameFilter,
            Skip: all ? 0 : (this.state.mainPage * pageSize * pageQuantity),
            Take: all ? 0 : ((pageSize * pageQuantity) + 1),
        };
        return tranWebModel;
    }

    componentDidUpdate(prevProps: IProps, prevState: IState) {
        if (prevState.transactions !== this.state.transactions) {
            this.setState({ columns: this.updateColumnDefinition() })
        }
    }

    shouldShowAction(transaction: ITransaction): ActionResult {
        const isWithin31Days = (dateString: string): boolean => {
            const [datePart, timePart] = dateString.split(' ');
            const [day, month, year] = datePart.split('/').map(Number);
            const [hours, minutes, seconds] = timePart.split(':').map(Number);
            const transactionDate = new Date(year, month - 1, day, hours, minutes, seconds);
            const currentDate = new Date();
            const differenceInDays = Math.floor((currentDate.getTime() - transactionDate.getTime()) / (1000 * 3600 * 24));
            return differenceInDays < 31
        }
        const { transactionType, state, authDateTime, refundBalance } = transaction
        const refBalance = refundBalance ? parseFloat(refundBalance) : NaN
        const isRefBalanceToAmount = refundBalance === ""
        const isDateOutSide31Days = isWithin31Days(authDateTime)

        if ((transactionType === "C") && (state == 2) && (isDateOutSide31Days) && (refBalance > 0)) {
            return { show: true, type: 'defaultAction' }
        }

        if ((isRefBalanceToAmount) && (isDateOutSide31Days)) {
            return { show: true, type: 'refundAction' }
        }

        if (!isDateOutSide31Days) {
            return { show: true, type: 'noRefund' }
        }
        return { show: false, type: undefined }
    }

    handleCaptchaVerification = (verified: boolean) => {
        this.setState({ isCaptchaVerified: verified });
    };

    getTransactionsToExcel = () => {
        if (this.state.isCaptchaVerified) {
            this.messages.showDownloadMessage();
            TransactionService.getAllToExcel(this.getTransactionRequest(true))
                .then((response: AxiosResponse<Blob>) => {
                })
                .catch((error) => {
                    this.setState({ errors: error.response.data });
                });
        } else {
            toast.error("Por favor, verifica el CAPTCHA antes de descargar el archivo");
        }
    };

    getTransactions = () => {
        TransactionService.getQrTransactionsAll(this.getTransactionRequest(false)).then((response: AxiosResponse<ITransaction[]>) => {
            if (response == null || response.data == null || response.data.length == 0) {
                this.setState({
                    transactions: [],
                    columns: [],
                    errors: []
                })
                return;
            }
            this.setState({
                transactions: response.data,
                errors: [],
            }, () => this.updateColumnDefinition());
        }).catch(error => {
            this.setState({
                errors: error.response.data
            });
            this.setState({
                transactions: []
            })
            console.log('error:', error);
        }
        );
    }

    updateColumnDefinition() {
        const staticColumns: ColumnDefinition[] = [
            dateColumnDefinition({
                key: 'authDateTime', label: 'authDateTime', header: true, percentageWidth: 30, mapValue: (fechaOp: ITransaction) => {
                    const authDateTime: string = fechaOp.authDateTime
                    return UtilService.getDDMMyyHHmmssFormatFromString(authDateTime);
                }
            }),
            textColumnDefinition({
                key: 'transactionType', label: 'transactionType', header: true, percentageWidth: 10, mapValue: (tipo: ITransaction) => {
                    const transactionType: string = tipo.transactionType
                    return (t("transactionType-" + transactionType) + "")
                }
            }),
            textColumnDefinition({
                key: 'state', label: 'state', header: true, percentageWidth: 10, mapValue: (estado: ITransaction) => {
                    const state: number = estado.state
                    return (t("state-" + state) + "")
                }
            }),
            textColumnDefinition({
                key: 'issuer', label: 'issuer', header: true, percentageWidth: 10, mapValue: (imagen: ITransaction) => {
                    const issuer: string = imagen.issuer;
                    const inputMode = imagen.inputMode
                    if (inputMode === "QRFD") {
                        return <img src={TarjetaLogo} alt={'PCT'} />;
                    }
                    return <img src={UtilService.getImageTag((t("issuer-" + issuer) + "").toUpperCase())} alt={`${issuer}`}></img>
                }
            }),
            textColumnDefinition({
                key: 'walletProductId', label: 'wallet', header: true, percentageWidth: 10, mapValue: (imagen: ITransaction) => {
                    const walletProductId = imagen.walletProductId;
                    return <img src={UtilService.getImageTag((t("issuer-" + walletProductId) + "").toUpperCase())} alt=''></img>
                }
            }),
            currencyColumnDefinition({ key: 'totalAmountForReport', label: 'totalAmountForReport', header: true, percentageWidth: 10, columnDefinitionKey: 'currency' }),
            textColumnDefinition({ key: 'muId', label: 'muId', header: true, percentageWidth: 10 }),
            actionColumnDefinition({
                key: "Gestion", label: "Gestión", header: true, action: {
                    function: (transaction: ITransaction) => {
                        const action = this.shouldShowAction(transaction)
                        if (!action.show) {
                            return null;
                        }
                        switch (action.type) {
                            case 'defaultAction':
                                return this.processAction(transaction)
                            case 'refundAction':
                                return null
                            case 'noRefund':
                                return null
                            default:
                                return null
                        }
                    },
                    icon: (transaction: ITransaction) => {
                        const action = this.shouldShowAction(transaction)
                        if (!action.show) {
                            return null;
                        }
                        switch (action.type) {
                            case 'defaultAction':
                                return <div className='containerIconRefund'> <i className='fa-solid fa-file-invoice-dollar fa-lg iconRefund '><p className='textIconRefund'>Devolver Dinero</p></i></div>
                            case 'refundAction':
                                return <div className='containerIconRefund'> <i className='fa-solid fa-check iconRefund'><p className='textIconRefund'>Devoluciones realizadas con éxito</p></i></div>
                            case 'noRefund':
                                return <div className='containerIconRefund'> <i className='fa-solid fa-x iconRefund'><p className='textIconRefund'>No es posible realizar devoluciones</p></i></div>
                            default:
                                return ""
                        }
                    }
                }
            })
            ,
            textColumnDefinition({ key: 'merchant', label: 'merchantNro', header: false, percentageWidth: 20 }),
            textColumnDefinition({
                key: 'terminal', label: 'terminal', header: false, percentageWidth: 20, mapValue: (t: ITransaction) => {
                    const terminal: string = t.terminal
                    if (terminal.toString().includes("B24_")) {
                        return terminal.toString().substring(4);
                    } else {
                        return terminal + "";
                    }
                }
            }),
            textColumnDefinition({
                key: 'refundBalance', label: 'refundBalance', header: false, percentageWidth: 20, mapValue: (rowObjects: ITransaction) => {
                    const refundBalance = rowObjects.refundBalance
                    let transactionType = rowObjects.transactionType
                    if (transactionType === "D") {
                        return "-"
                    } else {
                        return Intl.NumberFormat('es-UY', { style: 'currency', currency: "UYU" }).format(Number(refundBalance))
                    }
                }
            }),
            actionColumnDefinition({
                key: 'relatedTransactions', label: 'transactionsVinculated', header: false, percentageWidth: 20, action: {
                    function: this.showTotalRefundAction.bind(this),
                    icon: 'fa-solid fa-magnifying-glass'
                }
            }),
            textColumnDefinition({ key: 'userId', label: 'userName', header: false, percentageWidth: 10 })
        ]
        return staticColumns
    }

    showTotalRefund: (rowObject: ITransaction, detailOptions: BuildTotalDetailOptions) => void = (rowObject: ITransaction, detailOptions: BuildTotalDetailOptions): void => {
        if (detailOptions) {
            const currencySymbol: string = CurrencyHelper.getCurrencySymbol(rowObject.currency);
            this.setState({
                ...this.state,
                rowDetail: TransactionService.buildTotalDetail(detailOptions.object, detailOptions.title, currencySymbol, detailOptions.accumulateTotal),
            });
        }
    };

    showTotalRefundAction: (rowObject: ITransaction) => void = (rowObject: ITransaction): void => {
        var o: any = {};
        let label = i18next.t('relatedTransactions');
        let accumulateTotal = true;
        if (rowObject.transactionType == "D") {
            label = i18next.t('relatedSale');
            accumulateTotal = false;
        }
        for (var i in rowObject.relatedTransactions) {
            o[rowObject.relatedTransactions[i].transactionReference] = Number.parseInt(rowObject.relatedTransactions[i].amount) / 100;
        }
        this.showTotalRefund(rowObject, { object: o, title: label, accumulateTotal: accumulateTotal });
    };

    getFromBuscar = () => {
        this.setState({
            ...this.state,
            activePage: 1,
            pages: defaultPages,
            mainPage: 0
        }, () => {
            this.getTransactions()
        })
    }
    openAmountModal = () => {
        this.setState({ showModalAmount: true })
    }

    closeAmountModal = () => {
        this.setState({ showModalAmount: false, isAmountValid: true, isAmountNotEmpty: false })
    }

    openAuthModal = () => {
        this.setState({ showModalAuth: true })
    }

    closeAuthModal = () => {
        this.setState({ showModalAuth: false, otpCodeForm: { otpCode: "" }, isOTPError: false })
    }

    openConfirmationModal = () => {
        this.setState({ showModalConfirmation: true })
    }

    closeConfirmationModal = () => {
        this.setState({ showModalConfirmation: false })
    }

    processAction = (transaction: ITransaction) => {
        this.openAmountModal();
        this.setState({ selectedTransactions: transaction })
    };

    // Lógica para la solicitud del MFA
    handleMfaConfirmation = async () => {
        this.closeAmountModal();
        this.openAuthModal();
        await TOTPService.getMfaDevices()
            .then((response) => {
                const data = response.data.deviceName;
                if (Array.isArray(data)) {
                    this.setState({ mfaDevices: data })
                } else {
                    toast.error("Error: Respuesta de dispositivos MFA incorrecta");
                }
            })
            .catch((error) => {
                console.error("Error en la solicitud de dispositivos MFA:", error);
            });
    };

    handleSubmitOTP = (): void => {
        const request: AuthenticateTotpDevice = {
            deviceName: this.state.mfaDevices[0],
            otpCode: this.state.otpCodeForm.otpCode,
        };
        TOTPService.authenticateTotpDevice(request)
            .then((response) => {
                const data = response.data;
                if (data.success) {
                    this.openConfirmationModal();
                    this.closeAuthModal()
                } else {
                    this.setState({ isOTPError: true })
                }
            })
            .catch((error) => {
                console.error("Error en la solicitud de autenticación OTP:", error);
            });
    }

    // Lógica para aceptar o no la solicitud de devolución
    handleConfirmation = (isAccepted: boolean) => {
        const request = {
            terminal: this.state.selectedTransactions?.terminal || '',
            amount: this.state.enteredAmount.toString(),
            currency: this.state.selectedTransactions?.currency || '',
            originalMuId: this.state.selectedTransactions?.muId || '',
            originalTerminal: this.state.selectedTransactions?.terminal || '',
            merchantCode: this.state.selectedTransactions?.merchant || '',
            originalIssuer: this.state.selectedTransactions?.issuer || ''
        };
        if (isAccepted) {
            MconboardingService.insertQrRefund(request).then((res) => {
                if (res.data.success) {
                    Swal.fire({
                        html: ("Devolución realizada con éxito"),
                        confirmButtonColor: '#f60',
                        icon: "success"
                    });
                    this.refreshTransactions();
                } else {
                    Swal.fire({
                        html: (" Se está procesando su devolución, podrá visualizarla en los próximos minutos."),
                        confirmButtonColor: '#f60',
                        icon: "success"
                    });
                    this.refreshTransactions();
                }
            }).catch((error) => {
                Swal.fire({
                    html: ('Error al realizar la devoluci&oacute;n'),
                    confirmButtonColor: '#f60',
                    icon: "error"
                });
                this.closeConfirmationModal()
            })
        } else {
            toast.error('Solicitud de devolución cancelada')
        }
    }

    //refreshTransactions --> Lógica para refrescar la busqueda y que se muestren todas las transacción con las devoluciones una vez que se hayan realizado
    refreshTransactions = () => {
        this.setState({
            ...this.state, activePage: 1, pages: defaultPages,
            mainPage: 0,
            showModalConfirmation: false
        }, this.getTransactions);
    }

    buildIssuerSelectOptions() {
        let options = this.optionMapper.buildSelectOptionsFromAnArrayWithDifferentInterface(this.state.currentIssuers, 'id', 'issuerName');
        const allIndex = options.findIndex(option => option.value === '0000');

        if (allIndex !== -1) {
            const todosOption = options.splice(allIndex, 1)[0];
            options = [todosOption, ...options];
        }
        options.sort((a, b) => {
            if (a.label === 'Todos') return -1;
            if (b.label === 'Todos') return 1;
            return a.label.localeCompare(b.label);
        });

        return options;
    }

    buildOperationTypeSelectOptions() {
        const translationKeys = allowedOperationTypes.map((type) => {
            if (type === 'C') {
                return `${T_PREFIX}operationType-CPT`;
            }
            return `${T_PREFIX}operationType-${type}`;
        });
        const translatedOptions: { value: string; label: string }[] = translationKeys.map((key, index) => ({
            value: allowedOperationTypes[index],
            label: t(key),
        }));
        return translatedOptions;
    }
    setOtpCodeForm(otpCodeForm: CodeFormType) {
        this.setState({ ...this.state, otpCodeForm });
    }

    clearFilters = () => {
        let [fromDate, toDate] = DateHelper.buildDateRange();
        this.setState({
            ...this.state,
            fromDate: fromDate,
            toDate: toDate,
            operationTypeFilter: '',
            issuerFilter: '',
            amountFilter: '',
            terminalFilter: '',
            merchantFilter: "",
            paymentmodeFilter: "",
            muidFilter: "",
            userNameFilter: '',
            tranId: "",
        }, () => {
            this.getFromBuscar();
        });
    }

    render() {
        const { t } = this.props;
        const { otpCode } = this.state.otpCodeForm
        return (
            <><>
                <TotalTransactions rowDetail={this.state.rowDetail} link={null}></TotalTransactions>
                {/* Modal para ingresar monto a devolver */}
                <Modal show={this.state.showModalAmount}>
                    <div className="mt-5">
                        <div className='brand-logo-container'>
                            <LogoSVG className='logo-image' ></LogoSVG>
                        </div>
                        <div className="modal-body modalTransfersReturn">
                            <div className='w-75'>
                                <p className='textAmount'>{t(`${T_PREFIX}amountReturn`)}</p>
                                <CurrencyInput
                                    className="border-start-0 ms-0 form-control inputAmount"
                                    placeholder={t(`${T_PREFIX}amount`)}
                                    allowDecimals={true}
                                    decimalsLimit={2}
                                    required
                                    disableGroupSeparators={true}
                                    onChange={(event) => {
                                        const value = event.target.value.trim();
                                        if (value.length > 0) {
                                            this.setState({ isAmountNotEmpty: true });
                                        }
                                        // Verificar y limpiar la entrada para trabajar con centavos
                                        let separator = ".";
                                        if (value.includes(",")) separator = ",";
                                        let fields = value.split(separator);
                                        if (fields.length === 2) {
                                            fields[1] = fields[1].padEnd(2, "0").substring(0, 2);
                                        } else if (fields.length > 2) {
                                            this.setState({ isAmountValid: false });
                                            return;
                                        } else {
                                            fields.push("00");
                                        }
                                        // Convertir el monto a centavos (evitando errores de precisión)
                                        const enteredAmount = parseInt(fields[0] + fields[1], 10);
                                        if (!isNaN(enteredAmount) && this.state.selectedTransactions?.refundBalance) {
                                            const totalAmountForReport = Math.round(Number(this.state.selectedTransactions.refundBalance) * 100);
                                            if (enteredAmount > 0 && enteredAmount <= totalAmountForReport) {
                                                this.setState({
                                                    enteredAmount,
                                                    isAmountValid: true,
                                                    isAmountNotEmpty: true
                                                });
                                            } else {
                                                this.setState({ isAmountValid: false });
                                            }
                                        }
                                    }} />
                                {!this.state.isAmountValid && <p className="text-danger">{t(`${T_PREFIX}wrongAmount`)}</p>}
                            </div>
                        </div>
                        <div className="modalFooter">
                            <Button color="white" label={t(`${T_PREFIX}cancel`)} className="me-3" onClick={() => this.closeAmountModal()} noBlock></Button>
                            <SubmitButton onClick={() => this.handleMfaConfirmation()} disabled={!this.state.isAmountValid || !this.state.isAmountNotEmpty} noBlock>{t(`${T_PREFIX}continue`)}</SubmitButton>
                        </div>
                    </div>
                </Modal>

                {/* Modal para ingresar el codigo OTP */}
                <Modal show={this.state.showModalAuth} size="lg">
                    <div className="m-5">
                        <div className='brand-logo-container'>
                            <LogoSVG className='logo-image' ></LogoSVG>
                        </div>
                        <Form model={[this.state.otpCodeForm, this.setOtpCodeForm.bind(this)]} onSubmit={() => this.handleSubmitOTP()}>
                            <>
                                <div className="modal-body modalTransfersReturn">
                                    <div className='w-75'>
                                        <p className='textAmount'>{t(`${T_PREFIX}message`)}</p>
                                        <TextField attr='otpCode' label={`${T_PREFIX}code`} required autoFocus />
                                        {this.state.isOTPError && <LabelMessage valid={false} message={t(`${T_PREFIX}wrongCode`)} />}
                                    </div>
                                </div>
                                <div className="modalFooter">
                                    <Button color="white" label={t(`${T_PREFIX}cancel`)} className="me-3" onClick={() => this.closeAuthModal()} noBlock></Button>
                                    <SubmitButton label={t(`${T_PREFIX}continue`)} disabled={otpCode === ''} noBlock />
                                </div>
                            </>
                        </Form>
                    </div>
                </Modal>

                {/* Modal para confirmar monto a devolver */}
                <Modal show={this.state.showModalConfirmation} size="lg">
                    <div className="m-5">
                        <div className='brand-logo-container'>
                            <LogoSVG className='logo-image' ></LogoSVG>
                        </div>
                        <div className="modal-body modalTransfersReturn">
                            <div className='w-50'>
                                <p className='text-center textAmount'>{t(`${T_PREFIX}returnRequest`)}</p>
                                <p className='text-center'><span>{t(`${T_PREFIX}amountToReturn`)} : </span>${(Number(this.state.enteredAmount) / 100).toFixed(2).replace('.', ',')}</p>
                                <p className='text-center'><span>{t(`${T_PREFIX}wallet`)} :</span> {t("issuer" + "-" + (this.state.selectedTransactions?.issuer))} </p>
                                <p className='text-center'><span>{t(`${T_PREFIX}transactionType`)} :</span> {t("transactionType" + "-" + (this.state.selectedTransactions?.transactionType))} </p>
                                <p className='text-center'><span>{t(`${T_PREFIX}id`)} : </span> {this.state.selectedTransactions?.muId}</p>
                                <div className="modalFooter">
                                    <Button color="white" label={t(`${T_PREFIX}cancel`)} className="me-3" onClick={() => this.closeConfirmationModal()} noBlock></Button>
                                    <SubmitButton onClick={() => this.handleConfirmation(true)} noBlock>{t(`${T_PREFIX}confirm`)}</SubmitButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </>
                <Page>
                    <>
                        <div className='row'>
                            <h2>{t(`${T_PREFIX}title`)}</h2>
                            <div className='col-lg-12'>
                                <ErrorsView errors={this.state.errors} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-header">
                                        <NavigationTabLinksForCharges></NavigationTabLinksForCharges>
                                    </div>
                                    <div className="card-body">
                                        <FormFilter
                                            onSubmit={this.getFromBuscar.bind(this)}
                                            model={[this.state, this.setState.bind(this)]}
                                            clear={() => { this.clearFilters() }}
                                            hidden={UtilService.isMobilePlatform() ? true : false}
                                        >
                                            <>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <DateField attr='fromDate' label='authDateTimeFrom'></DateField>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <DateField attr='toDate' label='authDateTimeTo'></DateField>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <SelectField
                                                            attr='operationTypeFilter'
                                                            label={t(`${T_PREFIX}transactionType`)}
                                                            options={this.buildOperationTypeSelectOptions()}
                                                        ></SelectField>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <SelectField attr='issuerFilter' label={t(`${T_PREFIX}wallet`)} options={this.buildIssuerSelectOptions()}></SelectField>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <TextField attr='merchantFilter' label={t(`${T_PREFIX}merchant`)}></TextField>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <TextField attr='terminalFilter' label='terminal'></TextField>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <NumericField attr='amountFilter' label='amount'></NumericField>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <TextField attr='muidFilter' label={t(`${T_PREFIX}idFilter`)}></TextField>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <TextField attr='userNameFilter' label={t(`${T_PREFIX}userName`)}></TextField>
                                                    </div>
                                                </div>
                                            </>
                                        </FormFilter>
                                        <div className='row'>
                                            <div className="col-md-12 accordion-table">
                                                {UtilService.isMobilePlatform() ?
                                                    <div>
                                                        <div className="container">
                                                            <ul className="notification">
                                                                {
                                                                    this.state.transactions.slice(this.state.pages.indexOf(this.state.activePage) * pageSize, (this.state.pages.indexOf(this.state.activePage) * pageSize) + pageSize).map((transaction, Tindex) => {
                                                                        return (
                                                                            <li>
                                                                                <div className="notification-time-date mb-2 d-block d-md-none">
                                                                                    <span className="date">{transaction.authDateTime}</span>
                                                                                </div>
                                                                                <div className="settlementMobile">
                                                                                    <div className="media mt-0" style={{ display: 'flex', flexDirection: 'row', alignItems: 'stretch' }}>
                                                                                        <div className="main-avatar avatar-md online d-flex align-items-center justify-content-center" style={{ flex: '0 0 60px', minWidth: 0 }}>
                                                                                            <img alt="avatar" className="br-7 transaction-image" src={UtilService.getImageTag(t("issuer-" + transaction.issuer).toUpperCase())} />
                                                                                        </div>
                                                                                        <div className="d-flex flex-column justify-content-center" style={{ minWidth: 0, padding: '0 10px' }}>
                                                                                            <span className="amount-labelSettlement">{Intl.NumberFormat('es-UY', {
                                                                                                style: 'currency',
                                                                                                currency: CurrencyHelper.getCurrencySymbol(transaction.currency)
                                                                                            }).format(transaction.totalAmountForReport)}</span>
                                                                                            <p className="mb-0 fs-13 text-muted">{t("transactionType-" + transaction.transactionType)}</p>
                                                                                            <p className='mb-0 fs-13 text-muted'>{t("state-" + transaction.state)}</p>
                                                                                            <p className='mb-0 fs-13 text-muted'>{t("terminal")}: {transaction.terminal}</p>
                                                                                            <p className='mb-0 fs-13 text-muted'>{t("wallet") + " : "}{t("issuer-" + transaction.walletProductId)}</p>
                                                                                            <p className='mb-0 fs-13 text-muted'>{t("muId") + " : "}{transaction.muId}</p>
                                                                                            <p className='mb-0 fs-13 text-muted'>{t("merchant") + " : "}{transaction.merchant}</p>
                                                                                        </div>
                                                                                        <div style={{ flex: '0 0 60px', minWidth: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                            {(() => {
                                                                                                const action = this.shouldShowAction(transaction);
                                                                                                if (!action.show) {
                                                                                                    return null;
                                                                                                }
                                                                                                switch (action.type) {
                                                                                                    case 'defaultAction':
                                                                                                        return (
                                                                                                            <button type="button" onClick={() => this.processAction(transaction)} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
                                                                                                                <div className='containerIconRefund'>
                                                                                                                    <i className='fa-solid fa-file-invoice-dollar fa-lg iconRefund'>
                                                                                                                        <p className='textIconRefund'>Devolver Dinero</p>
                                                                                                                    </i>
                                                                                                                </div>
                                                                                                            </button>
                                                                                                        );
                                                                                                    case 'refundAction':
                                                                                                        return (
                                                                                                            <div className='containerIconRefund'>
                                                                                                                <i className='fa-solid fa-check iconRefund'>
                                                                                                                    <p className='textIconRefund'>Devoluciones realizadas con éxito</p>
                                                                                                                </i>
                                                                                                            </div>
                                                                                                        );
                                                                                                    case 'noRefund':
                                                                                                        return (
                                                                                                            <div className='containerIconRefund'>
                                                                                                                <i className='fa-solid fa-x iconRefund'>
                                                                                                                    <p className='textIconRefund'>No es posible realizar devoluciones</p>
                                                                                                                </i>
                                                                                                            </div>
                                                                                                        );
                                                                                                    default:
                                                                                                        return null;
                                                                                                }
                                                                                            })()}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                        )
                                                                    })}
                                                            </ul>
                                                        </div>
                                                        <div>
                                                            <Pagination
                                                                pageSize={pageSize}
                                                                pageQuantity={pageQuantity}
                                                                modifyMainPage={(value: number, newPages: Array<number>) => {
                                                                    this.setState({
                                                                        mainPage: this.state.mainPage + value,
                                                                        pages: newPages
                                                                    }, () => this.getTransactions());
                                                                }}
                                                                changePage={(page: number) => this.setState({ activePage: page }, () => this.getTransactions())}
                                                                dataL={this.state.transactions.length}
                                                                mainPage={this.state.mainPage}
                                                            ></Pagination>
                                                        </div>
                                                    </div>
                                                    : <CustomTable
                                                        rowObjects={this.state.transactions}
                                                        columnDefinitions={this.updateColumnDefinition()}
                                                        config={{
                                                            mode: this.state.tableMode,
                                                            paginator: {
                                                                mainPage: this.state.mainPage,
                                                                modifyMainPage: (value: number) => {
                                                                    this.setState({
                                                                        mainPage: this.state.mainPage + value
                                                                    }, () => this.getTransactions());
                                                                },
                                                                pageRequest: this.state.pageRequest
                                                            },
                                                        }}
                                                    ></CustomTable>
                                                }
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-md-6'></div>
                                            <div className="col-md-3">
                                                <CustomReCAPTCHA useCache={true} onVerify={this.handleCaptchaVerification} />
                                            </div>
                                            <div className="col-md-2">
                                                <Button className=" btn btn-block mt-3" disabled={this.state.transactions.length === 0} onClick={() => { this.getTransactionsToExcel() }}>
                                                    {t("excel")}
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                </Page></>
        )
    };
}
export default withMessages(withTranslation()(TransfersReturnReport));